import React, { useEffect } from "react";
import { auth } from "../firebase-config";

export const GameOnboarding = ({ setTab }) => {
  useEffect(() => {
    // Check if user is anonymous and redirect to profile if so
    if (auth.currentUser && auth.currentUser.isAnonymous) {
      console.log("Anonymous user detected, redirecting to profile");
      if (setTab) {
        setTab("profile");
      }
    }
  }, [setTab]);

  return (
    <div className="game-onboarding">
      <div className="onboarding-container">
        <div className="onboarding-header">
          <h1 className="text-3xl font-bold text-white mb-4">
            Welcome to Jukebox Showdown!
          </h1>
          <p className="text-lg text-gray-300 mb-8">
            Test your music knowledge and compete with friends
          </p>
        </div>

        <div className="onboarding-content">
          <div className="feature-cards">
            <div className="feature-card">
              <div className="icon-wrapper">
                <span className="icon">🎵</span>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">
                Music Trivia
              </h3>
              <p className="text-gray-400">
                Answer questions about your favorite songs and artists
              </p>
            </div>

            <div className="feature-card">
              <div className="icon-wrapper">
                <span className="icon">🏆</span>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">
                Win Rewards
              </h3>
              <p className="text-gray-400">
                Earn diamonds and climb the leaderboard
              </p>
            </div>

            <div className="feature-card">
              <div className="icon-wrapper">
                <span className="icon">👥</span>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">
                Team Play
              </h3>
              <p className="text-gray-400">
                Create or join teams to compete together
              </p>
            </div>
          </div>

          <div className="onboarding-actions">
            <button className="btn-primary">
              Get Started
            </button>
            <button className="btn-secondary">
              Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};